import Vue from 'vue';
import Vuex from 'vuex';

import auth from '@/store/modules/auth';
import simulation from '@/store/modules/simulation';
import preloader from '@/store/modules/preloader';
import favorites from '@/store/modules/favorites';
import comparing from '@/store/modules/comparing';
import calendar from '@/store/modules/calendar';
import charts from '@/store/modules/charts';

Vue.use(Vuex);
 
export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    simulation,
    preloader,
    favorites,
    comparing,
    calendar,
    charts
  }
})
